'use strict';

var privatePropertyAccessor = require('../../common/internal/privatePropertyAccessor');

module.exports = privatePropertyAccessor('partial');


//////////////////
// WEBPACK FOOTER
// ./~/sugar/function/var/_partial.js
// module id = 300
// module chunks = 0